export default "__VITE_ASSET__da4c4681__"